import {
    BZFORM_LOCATION_SELECT_ENTER_SOME_CHARS,
    BZFORM_LOCATION_SELECT_NO_RESULTS,
    BZFORM_LOCATION_SELECT_SEARCHING,
} from 'mk/autogenerated/translations/LocationSelect.a41ba4ffca685415852c6dd8bfd17b61'
import { MobileDropdownAdapter } from 'mk/bzforms/mobileDropdown';
import { geo_place_suggest_url } from 'mk/urls/functions';
import './select2';

export const LocationSelect = {
    init(selectElem, dropdownParent, placeholder, { allowClear = false } = {}) {
        selectElem.select2({
            placeholder,
            dropdownParent,
            dropdownAdapter: MobileDropdownAdapter,
            language: {
                inputTooShort() {
                    return BZFORM_LOCATION_SELECT_ENTER_SOME_CHARS;
                },
                searching() {
                    return BZFORM_LOCATION_SELECT_SEARCHING;
                },
                noResults() {
                    return BZFORM_LOCATION_SELECT_NO_RESULTS;
                },
            },
            minimumInputLength: 2,
            ajax: {
                url: geo_place_suggest_url(),
                dataType: 'json',
                delay: 250,
                data(params) {
                    return {
                        q: params.term,
                        county: (window as any).dangerouslySetVariableOnWindowObjectProfileSettingsCountyId,
                    };
                },
                processResults(data) {
                    return {
                        results: data,
                    };
                },
                cache: true,
            },
            escapeMarkup(m) { return m; },
            allowClear,
        });
    },
};
